import { render, staticRenderFns } from "./ImageCollection.vue?vue&type=template&id=3d7614b2"
import script from "./ImageCollection.ts?vue&type=script&lang=ts&external"
export * from "./ImageCollection.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports